import { render, staticRenderFns } from "./hetong.vue?vue&type=template&id=2a2ee020&scoped=true"
import script from "./hetong.vue?vue&type=script&lang=js"
export * from "./hetong.vue?vue&type=script&lang=js"
import style0 from "./hetong.vue?vue&type=style&index=0&id=2a2ee020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2ee020",
  null
  
)

export default component.exports